export default {
      id: "list-usage",
      viewBox: "0 0 24 20",
      url: __webpack_public_path__ + "img/icons.deccda40.svg#list",
      toString: function () {
        return this.url;
      }
    }